import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type TypeCheckPasswordStore = {
  /** 비밀번호 페이지 통과 여부 */
  isChecked: boolean;
  /** 비밀번호 토큰 유효성 검사 여부 */
  isValidPassToken: boolean;
  /** 비밀번호 토큰 */
  passToken: string;
  actions: {
    setIsChecked: (isChecked: boolean) => void;
    setIsValidPassToken: (isValidPassToken: boolean) => void;
    setPassToken: (passToken: string) => void;
    resetIsChecked: () => void;
    resetIsValidPassToken: () => void;
    resetPassToken: () => void;
    resetCheckPassword: () => void;
  };
};

/** @description 비밀번호 재확인 상태 */
export const useCheckPasswordStore = create<TypeCheckPasswordStore>()(
  devtools((set) => ({
    isChecked: false,
    isValidPassToken: false,
    passToken: '',
    actions: {
      setIsChecked: (isChecked) => set({ isChecked }),
      setIsValidPassToken: (isValidPassToken) => set({ isValidPassToken }),
      setPassToken: (passToken) => set({ passToken }),
      resetIsChecked: () => set({ isChecked: false }),
      resetIsValidPassToken: () => set({ isValidPassToken: false }),
      resetPassToken: () => set({ passToken: '' }),
      resetCheckPassword: () => set({ isChecked: false, isValidPassToken: false, passToken: '' }),
    },
  }))
);
